module.exports = __webpack_public_path__ + "img/icon_flag_bl.850c77d3.svg";